// extracted by mini-css-extract-plugin
module.exports = {"root":"CZU1X09o","titleDescriptionWrapper":"ELQNxzhU","titleText":"GGcAVUpi","descriptionText":"b27us7nh"};